import React, { useEffect } from "react";
import { Link as RouterLink, Redirect } from "react-router-dom";
import { Box, Link } from "@chakra-ui/react";
import { LoginForm } from "./LoginForm";
import { ReactComponent as Logo } from "assets/logo.svg";
import { ReactComponent as CBHLogo } from "assets/cbh_logo.svg";
import { isLogin, saveToken, tokenAction } from "utils/auth";
import { FormWrapper } from "components";
import { BasicLayout } from "layouts";
import { loginWithLink } from "api/webservice/auth";
import { useToast } from "hooks";

const Login: React.FC = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");
  const toast = useToast();

  useEffect(() => {
    if (!token || tokenAction(token) !== "loginLink") return;

    loginWithLink(token)
      .then(response => {
        // A forced-reset user gets a passwordExpired payload with a reset token
        // instead of a session token; route them into the reset flow.
        if (response?.passwordExpired && response.resetToken) {
          toast({
            title: "Password expired",
            description:
              response.message ||
              "Your password has expired. Please reset your password.",
            status: "warning"
          });
          window.location.replace(
            `/reset-password?token=${encodeURIComponent(response.resetToken)}`
          );
          return;
        }

        const token = response?.token ?? null;
        const profile = response?.profile ?? null;

        if (token && profile) {
          saveToken(token);
          window.location.replace("/");
          window.location.reload;
        } else {
          toast({
            title: "Failed to login with link",
            description: "Please refresh the page and try again.",
            status: "error"
          });
        }
      })
      .catch(error => {
        toast({
          title: "Failed to login with link",
          description: error.response.data.response,
          status: "error"
        });
      });
  }, [token]);

  if (isLogin()) return <Redirect push to="/" />;

  return (
    <BasicLayout showBackgroundImage>
      <Box>
        <FormWrapper
          aboveForm={
            <Box maxW="300px" margin="0 auto">
              <Logo width="100%" />
            </Box>
          }
          form={<LoginForm />}
          belowForm={
            <Box textAlign="center" color="gray.200">
              <Link as={RouterLink} to="/forgot-password">
              Can&apos;t log in?
              </Link>
            </Box>
          }
        />
        <Box
          h="63px"
          position={["relative", "fixed"]}
          bottom={[null, 8]}
          m={["0 auto", null]}
          mt={4}
          left={[null, 8]}
        >
          <CBHLogo width="100%" height="100%" />
        </Box>
      </Box>
    </BasicLayout>
  );
};

export default Login;
